export default __webpack_public_path__ + "static/Overseas_Student_Enrolment_Form-5a148f2ba0cc889511ad834b1b194032.pdf";